import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";

export const PayrollFederalEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Federal Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll Federal Earnings", navigateTo: "/company/payrollFederalEarnings/setup" }
      ]}
      mainContents={<PayrollFederalEarningsSetup />}
    />
  );
};
